module.exports = __webpack_public_path__ + "img/login_background.57ebfa44.png";